(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
    const blockId = 'PdpNewsletter-{{ section.id }}-{{ block.id }}';

    const init = () => {
      const container = document.getElementById(blockId);
      if (!container || container.dataset.newsletterAjaxInitialized === 'true') return;
      container.dataset.newsletterAjaxInitialized = 'true';

      const form = container.querySelector('.pdp-newsletter__form');
      if (!form) return;

      const input = form.querySelector('.pdp-newsletter__input');
      const submitButton = form.querySelector('.pdp-newsletter__button');
      const errorMessage = form.querySelector('.pdp-newsletter__message--error');
      const successMessage = container.querySelector('.pdp-newsletter__message--success-js');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (submitButton) submitButton.disabled = true;
        if (errorMessage) errorMessage.hidden = true;

        try {
          const response = await fetch('/contact', {
            method: 'POST',
            body: new FormData(form),
            headers: {
              Accept: 'text/html'
            }
          });

          if (!response.ok) {
            throw new Error(`Newsletter signup failed (${response.status})`);
          }

          container.classList.add('is-success');
          if (successMessage) successMessage.hidden = false;
          if (input) input.value = '';
        } catch (error) {
          if (errorMessage) errorMessage.hidden = false;
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-note"] && !Shopify.designMode) return;
  try {
    (() => {
    const block = document.querySelector('.pdp-shipping-note--{{ block.id }}');
    if (!(block instanceof HTMLElement)) return;

    const productId = block.dataset.productId;
    const textEl = block.querySelector('[ref="shippingNoteText"]');
    const dotEl = block.querySelector('[ref="shippingNoteDot"]');
    if (!(textEl instanceof HTMLElement) || !(dotEl instanceof HTMLElement)) return;

    const inStockText = block.dataset.inStockText || textEl.textContent || '';
    const outOfStockText = block.dataset.outOfStockText || 'Out of stock';

    const setState = (isAvailable) => {
      textEl.textContent = isAvailable ? inStockText : outOfStockText;
      dotEl.classList.toggle('pdp-shipping-note__dot--out', !isAvailable);
    };

    document.addEventListener('variant:update', (event) => {
      const detail = event.detail || {};
      const detailProductId = detail?.data?.productId ? String(detail.data.productId) : '';
      if (productId && detailProductId && String(productId) !== detailProductId) return;

      const isAvailable = detail?.resource?.available === true;
      setState(isAvailable);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
